import type {EditorView} from '@codemirror/view'

import {registerInvalidVideoUrl} from '../extensions/invalid-video-urls'
import {VoidElementWidget} from './void-element'

/** `VideoElementWidget` is just like `VoidElementWidget` but registers invalid video URLs on error. */
export class VideoElementWidget extends VoidElementWidget {
  override toDOM(view: EditorView) {
    const videoElement = super.toDOM(view) as HTMLVideoElement
    videoElement.addEventListener('error', () => {
      registerInvalidVideoUrl(view, videoElement.src)
    })
    return videoElement
  }
}
